import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'BENCHMARK',
  initialState: {},
  reducers: {}
});

export default slice.reducer;
